import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { PAGE_STATE } from "../../../constants/constants";
import ResubmitDataService from "../../../../../services/ResubmitDataService";
import General from "../../../../../libs/utility/General";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { componentKey, setCheckForStateFrequencyPopup, setLoadingState, setPayerList, setReconciliationResubmitGridData, setStateWitheldPaymentFrequency, setSelectedStateWitheldPaymentFrequency, setPaginationState } from "./ReconciliationResubmitSlice";
import { TOASTER_VARIANT } from '../../../../components/toast/constants';
import ReconciliationDataService from "../../../../../services/ReconciliationDataService";
import ManageFormsService from "../../../../../services/ManageFormsService";
import { RECONCILIATION_RESUBMIT_LOADING_STATES } from "../constant";

export const { getPayersList, getReconciliationResubmitGridData, viewReconciliationPDF, resubmitRecon, getReconFrequencyPopUpOption } = {

    getPayersList: (payload) => {
        return {
            type: "RECONCILIATION_RESUBMIT/GET_PAYERS_LIST",
            payload
        }
    },

    getReconciliationResubmitGridData: (payload) => {
        return {
            type: "RECONCILIATION_RESUBMIT/GET_GRID_DATA",
            payload
        }
    },

    viewReconciliationPDF: (payload) => {
        return {
            type: "RECONCILIATION_RESUBMIT/VIEW_RECON_PDF",
            payload
        }
    },

    resubmitRecon: (payload) => {
        return {
            type: "RECONCILIATION_RESUBMIT/SUBMIT",
            payload
        }
    },
    getReconFrequencyPopUpOption: (payload) => {
        return {
            type: "RECONCILIATION_RESUBMIT/GET_RECON_FREQUENCY_POPUP",
            payload
        }
    }
}

function* getPayersListAsync(action) {
    try {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_LOADING }))

        const response = yield ResubmitDataService.getReconPayersList();

        const { Message, Status, Data } = response?.data;

        if (Status) {
            if(Data.length > 0){
                General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId")
                yield put(setPayerList(Data))
            }
        } else {
            yield put(addNotifications({ heading: "Failed to fetch reconciliation payers list", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch reconciliation payers list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_PAYERS_LIST_READY }))
    }
}

function* getReconciliationResubmitGridDataAsync(action) {
    try {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }))

        const { payerId, PageNumber, PageSize, IsDesc } = action.payload

        const params = {
            payerId,
            PageNumber,
            PageSize,
            FilterText: "",
            IdNumber: "",
            IsDesc,
        }

        const response = yield ResubmitDataService.getReconResubmitGridData(params);
        const { Message, Status } = response?.data;
        const Data =  General.extractDataFromResponseData(response.data)
        if (Status) {
            yield put(setReconciliationResubmitGridData(Data))
            yield put(setPaginationState({ total: General.extractPaginationTotalFromResponse(response.data) }))
        } else {
            yield put(addNotifications({ heading: "Failed to get reconciliation grid data", message: Message }));
        }

    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to get reconciliation grid data", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* viewReconciliationPDFAsync(action) {
    try {
        const { reconFormId, reconState, formName } = action.payload;
        yield put(setLoadingState({ state: `${RECONCILIATION_RESUBMIT_LOADING_STATES.VIEW_PDF_LOADING}-${reconFormId}` }));

        const params = { reconFormId, reconState, formName };
        const response = yield ManageFormsService.getReconciliationPDF(params);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            General.openBase64FileInNewTab(Data.Base64, Data.Name);
        } else {
            yield put(addNotifications({ heading: "Failed to open the PDF", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to open the PDF", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* resubmitReconAsync(action) {
    try {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));
        const { selectedForms, payerId, paginationState } = action.payload;

        const payload = {
            ResubmitRecon: selectedForms.map(form => {
                return {
                    State: form?.State,
                    FormIds: form?.Formids,
                    FormName: form?.FormName,
                    ReferenceId: form?.ReferenceNumber,
                }
            })
        };

        const response = yield ResubmitDataService.resubmitRecon(payload);
        const { Message, Status, Data } = response?.data;

        if (Status) {
            yield put(addNotifications({ heading: Message, variant: TOASTER_VARIANT.SUCCESS, message: "State Reconciliation resubmitted" }));
            yield put(getReconciliationResubmitGridData({ payerId, ...paginationState }));
        } else {
            yield put(addNotifications({ heading: "Failed to submit the form", message: Message }));
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to submit the form", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* getReconFrequencyPopUpOptionAsync(action){
    try {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));
        const {state, reconFormid} = action.payload;
        const response = yield ReconciliationDataService.getReconFrequencyPopUpOption(state, reconFormid);
        if(response.data){
            if(response?.data?.Status === 0){
                yield put(addNotifications({
                    heading: "Error",
                    message: response?.data?.Message,
                    variant: TOASTER_VARIANT.DANGER
                }));
            }else{
                const formFrequencyOptions = response?.data?.Data.forms;
                yield put(setStateWitheldPaymentFrequency(formFrequencyOptions));
                
                let idWithFiledquarterTrue = null;
                for (const key in formFrequencyOptions) {
                    if (formFrequencyOptions.hasOwnProperty(key)) {
                        const values = formFrequencyOptions[key];
                        for (const option of values) {
                            if (option.filedquarter) {
                                idWithFiledquarterTrue = option.id;
                                break;
                            }
                        }
                    }
                }
                if(idWithFiledquarterTrue){
                    yield put(setSelectedStateWitheldPaymentFrequency(idWithFiledquarterTrue));
                }
                yield put(setCheckForStateFrequencyPopup(true));
            }
        }
    } catch(error) {
        yield put(addNotifications({
            heading: "Error",
            message: error?.response?.data?.Message,
            variant: TOASTER_VARIANT.DANGER
        }));
    }finally {
        yield put(setLoadingState({ state: RECONCILIATION_RESUBMIT_LOADING_STATES.FETCHING_FORMS_LIST_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(getPayersList().type, getPayersListAsync),
        takeLatest(getReconciliationResubmitGridData().type, getReconciliationResubmitGridDataAsync),
        takeLatest(viewReconciliationPDF().type, viewReconciliationPDFAsync),
        takeLatest(resubmitRecon().type, resubmitReconAsync),
        takeLatest(getReconFrequencyPopUpOption().type, getReconFrequencyPopUpOptionAsync)
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);